<template>
    <router-view />
</template>
<script setup>
import {checkToken} from './utils/checkToken'
checkToken()
</script>
<style>
#app {
    position: absolute;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        color: #606266;
}
</style>
